/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './pager.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../src/app/shared/pager/pager.component';
const styles_PagerComponent:any[] = [i0.styles];
export const RenderType_PagerComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_PagerComponent,data:{}});
function View_PagerComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['←']))],(null as any),(null as any));
}
function View_PagerComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['→']))],(null as any),(null as any));
}
export function View_PagerComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),16,'nav',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),15,'ul',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),i1.ɵdid(278528,(null as any),
      0,i2.NgClass,[i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],
      {ngClass:[0,'ngClass']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      6,'li',[['class','pager__item']],[[2,'previous',(null as any)],[2,'disabled',
          (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),5,'span',[['class','pager__button']],
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i3.PagerComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onClick((0 - 1))) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_PagerComponent_1)),i1.ɵdid(16384,(null as any),0,i2.NgIf,
          [i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
          i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['',''])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),6,'li',[['class','pager__item']],[[2,'next',
              (null as any)],[2,'disabled',(null as any)]],(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          5,'span',[['class','pager__button']],(null as any),[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i3.PagerComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onClick(1)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['',''])),(_l()(),i1.ɵted((null as any),
          [' '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_PagerComponent_2)),i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,
          i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i3.PagerComponent = _v.component;
    const currVal_0:any = _co.classes;
    _ck(_v,2,0,currVal_0);
    const currVal_3:any = _co.aligned;
    _ck(_v,6,0,currVal_3);
    const currVal_8:any = _co.aligned;
    _ck(_v,16,0,currVal_8);
  },(_ck,_v) => {
    var _co:i3.PagerComponent = _v.component;
    const currVal_1:any = _co.aligned;
    const currVal_2:any = _co.prevDisabled;
    _ck(_v,3,0,currVal_1,currVal_2);
    const currVal_4:any = _co.prev;
    _ck(_v,9,0,currVal_4);
    const currVal_5:any = _co.aligned;
    const currVal_6:any = _co.nextDisabled;
    _ck(_v,10,0,currVal_5,currVal_6);
    const currVal_7:any = _co.next;
    _ck(_v,13,0,currVal_7);
  });
}
export function View_PagerComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-pager',
      ([] as any[]),(null as any),(null as any),(null as any),View_PagerComponent_0,
      RenderType_PagerComponent)),i1.ɵdid(638976,(null as any),0,i3.PagerComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const PagerComponentNgFactory:i1.ComponentFactory<i3.PagerComponent> = i1.ɵccf('admin-pager',
    i3.PagerComponent,View_PagerComponent_Host_0,{prev:'prev',next:'next',aligned:'aligned',
        prevDisabled:'prevDisabled',nextDisabled:'nextDisabled',color:'color'},{page:'page'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/pager/pager.component.ngfactory.ts